import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-section-container]', container).each((i, section) => {
    const $section = $(section);
    // weird things happen when you use the same format as shopify...
    const possibly_json = $section.children('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const {settings} = JSON.parse(json);

    $section.wrap(`
      <section class="Section Section--${settings.width} Section--${settings['width--mobile']}">
        <div class="Section__container">
        </div>
      </section>
    `);
  });
};